import { render, staticRenderFns } from "./health-hvalue.vue?vue&type=template&id=48d58c7e&scoped=true"
import script from "./health-hvalue.vue?vue&type=script&lang=js"
export * from "./health-hvalue.vue?vue&type=script&lang=js"
import style0 from "./health-hvalue.vue?vue&type=style&index=0&id=48d58c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d58c7e",
  null
  
)

export default component.exports